import { validator } from "@/utils/validator";

export type TPasskeyForm = {
  deviceName: string;
};

export const passkeySchema = validator.object().shape({
  deviceName: validator.string().trim().emptyToNull().max(100).label("デバイス名").required(),
});
